import React, { useState } from 'react';
import { Button, Loader, Text } from '@ui';
import { translate } from '@utils/i18n';
const namespace = 'features.reports.send_email';
export default function ReportPdfPreview({ pdfUrl, autoLoad = true, sizeLabel }) {
    const [requested, setRequested] = useState(autoLoad);
    const [loaded, setLoaded] = useState(false);
    if (!requested) {
        return (React.createElement("div", { className: "sendReportEmailModal__preview sendReportEmailModal__preview--deferred" },
            React.createElement(Text, { variant: "body", as: "p" }, translate('preview_too_large', { namespace, size: sizeLabel })),
            React.createElement("div", { className: "sendReportEmailModal__previewActions" },
                React.createElement(Button, { variant: "secondary", onClick: () => setRequested(true) }, translate('load_preview', { namespace })),
                React.createElement(Button, { variant: "secondary", onClick: () => {
                        window.open(pdfUrl, '_blank', 'noopener,noreferrer');
                    } }, translate('open_in_new_tab', { namespace })))));
    }
    return (React.createElement("div", { className: "sendReportEmailModal__preview" },
        !loaded && (React.createElement("div", { className: "sendReportEmailModal__previewLoading" },
            React.createElement(Loader, null))),
        React.createElement("object", { data: pdfUrl, type: "application/pdf", className: "sendReportEmailModal__pdf", "aria-label": translate('preview', { namespace }), onLoad: () => setLoaded(true) },
            React.createElement("a", { href: pdfUrl, target: "_blank", rel: "noopener noreferrer" }, translate('pdf_viewer_not_supported', { namespace })))));
}
